import React, {memo, useEffect} from 'react';
import Breadcrumbs from "@/app/components/breadcrumbs";
import styles from "./styles.module.scss";
import PeopleNearYou from "@/app/features/find_players/components/people_near_you/widget";
import useFindPlayers from "@/app/features/find_players/slice";
import {ThirtyText} from "@/app/components/texts";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import {handleMatchClick} from "@/app/utils/custom_function";
import GameRowWidget from "@/app/components/game_row_widget";
import {OpenMatchModelResponse} from "@/app/api/open_match";
import {useNavigate} from "react-router-dom";
import Space from "@/app/components/space";

const FindPlayersPage = () => {
  const {state, getNearMatches} = useFindPlayers();
  const navigate = useNavigate();

  useEffect(() => {
    getNearMatches();
  }, []);

  const onMatchClick = (match: OpenMatchModelResponse) => {
    handleMatchClick(match, navigate);
  };

  return (
    <div className={styles.findPlayers}>
      <Breadcrumbs items={state.items}/>
      <PeopleNearYou/>
      <div className={styles.matches}>
        <ThirtyText text={t(s.matchesNearYouReadyToPlay)}/>
        {(!state.matches || state.matches.length === 0) &&
            <div className={styles.centered}><ThirtyText text={t(s.noMatchesNearYou)}/></div>
        }
        <div className={styles.matchesList}>
          {state.matches?.map((g: OpenMatchModelResponse) => (
            <GameRowWidget 
              key={g.id} 
              match={g} 
              onClick={onMatchClick}
            />
          ))}
        </div>
      </div>
      <Space.H64/>
    </div>
  );
};

export default memo(FindPlayersPage);